import { Checkbox, DatePicker, Label, MenuContent, Radio, Stack } from 'src/app/components'

import MenuContentMall from 'src/app/components/Feedback/MenuContent/MenuContent.mall'
import { FilterMenuContentPrizeListProps } from 'src/app/components/Feedback/FilterMenu/FilterMenuContent.types'
import { useFilterMenuPrizeListHook } from './FilterMenuPrizeList.hooks'

function FilterMenuPrizeList(props: FilterMenuContentPrizeListProps) {

  const state = useFilterMenuPrizeListHook()

  const renderPrizeListTypeItem = (item: typeof state.master.prizeListTypes[0]) => {
    return (
      <Radio
        label={item.label}
        {...state.filterContext.registerRadio({ name: 'types', value: item.value })}
        key={item.value}
      />
    )
  }

  const renderPrizeListTypeItemSalesPromo = (item: typeof state.master.prizeListTypesSalesPromo[0]) => {
    return (
      <Checkbox
        label={item.label}
        {...state.filterContext.registerCheckbox({ name: 'types', value: item.value.split('.').pop() })}
        key={item.value}
      />
    )
  }

  return (
    <MenuContent>
      {!props.isSalesPromoPage && <>
        <div>
          <Label>Type</Label>
          <Stack direction="row" className='grid grid-cols-2 w-full'>
            {state.master.prizeListTypes.map(renderPrizeListTypeItem)}
          </Stack>
        </div>
        <MenuContentMall label='Draw Location' useName={true} filterContext={state.filterContext} />
        <DatePicker
          placeholder="Select date"
          onChange={state.action.handleDrawDate}
          format="DD/MM/YYYY"
          value={state.filterContext.draft?.draw_date}
          range={false}
          multiple={false}
          label="Draw Date"
        />
      </>}
      {props.isSalesPromoPage && <>
        <div>
          <Label>Prize Type</Label>
          <Stack direction="row" className='grid grid-cols-2 w-full'>
            {state.master.prizeListTypesSalesPromo.map(renderPrizeListTypeItemSalesPromo)}
          </Stack>
        </div>
        <DatePicker
          placeholder="Select date"
          onChange={state.action.handleValidDate}
          format="DD/MM/YYYY"
          value={state.filterContext.draft?.valid_until}
          range={false}
          multiple={false}
          label="Valid Until"
        />
      </>}
    </MenuContent>
  )
}

FilterMenuPrizeList.defaultProps = {
  isSalesPromoPage: false,
} as FilterMenuContentPrizeListProps

export { FilterMenuPrizeList }
